/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const TrainingIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 72"
    onClick={props.onClick}
  >
    <g fill="none">
      <g strokeWidth="2">
        <path d="M13.5 1.5h18v69h-18zM31.5 25.5h18v45h-18zM37.5 64.5h6M22.5 7.5v39" />
        <path d="M19.5 52.5h6v12h-6zM40.5 31.5v27M7.5 19.5v42M1.5 10.5h12v60h-12zM46.5 12l8.714-2.25 15 58.094-8.714 2.25z" />
      </g>
    </g>
  </svg>
);

export default TrainingIcon;
